import * as types from "./withdrawalActionTypes";

export default function withdrawalReducer(state = {}, action) {
  switch (action.type) {
    case types.CLEAR: {
      const newData = { [action.model.name]: {} };
      return { ...state, ...newData };
    }

    case types.FETCH: {
      const newData = { [action.payload.model.name]: { loaded: false } };
      return { ...state, ...newData };
    }
    case types.FETCH_FAILURE: {
      const newData = {
        [action.payload.model.name]: { ...action.payload, loaded: true },
      };
      return { ...state, ...newData };
    }
    case types.FETCH_SUCCESS: {
      const newData = {
        [action.payload.model.name]: { ...action.payload.data, loaded: true },
      };
      return { ...state, ...newData };
    }

    case types.WITHDRAW: {
      const newData = { withdrawing: { submitting: true, completed: false } };
      return { ...state, ...newData };
    }
    case types.WITHDRAW_FAILURE:
    case types.WITHDRAW_SUCCESS: {
      const newData = {
        withdrawing: { ...action.payload, submitting: false, completed: true },
      };
      return { ...state, ...newData };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal/withdrawalReducer.js